<template>
<div class="vlinePlaybackInterface bgc">
    <vliveHeader></vliveHeader>
    <div class="padding-20 playback-interface">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="直播封面" name="vliveCover">
                <vliveCover class="padding-20"></vliveCover>
                <vliveExample></vliveExample>
            </el-tab-pane>
            <el-tab-pane label="直播内容" name="vliveContent">
                <vliveContent class="padding-20"></vliveContent>
                <vliveExample></vliveExample>
            </el-tab-pane>
            <el-tab-pane label="微信分享" name="vliveWeChatShare">
                <vliveWeChatShare class="padding-20"></vliveWeChatShare>
                <vliveExampleWechatShare></vliveExampleWechatShare>
            </el-tab-pane>
            <el-tab-pane label="直播预告片" name="vliveTrailer">
                <vliveTrailer class="padding-20"></vliveTrailer>
            </el-tab-pane>
            <el-tab-pane label="引导封面" name="vliveGuideCover">
                <vliveGuideCover class="padding-20"></vliveGuideCover>
                <vliveExampleGuideCover></vliveExampleGuideCover>
            </el-tab-pane>
            <el-tab-pane label="关注微信公众号" name="vliveFollow">
                <vliveFollow class="padding-20"></vliveFollow>
                <vliveExample></vliveExample>
            </el-tab-pane>
            <el-tab-pane label="广告模板" name="vliveAdv">
                <vliveAdv class="padding-20"></vliveAdv>
                <vliveExample></vliveExample>
            </el-tab-pane>
            <el-tab-pane label="报名" name="vliveSignUp">
                <vliveSignUp class="padding-20"></vliveSignUp>
                <vliveExample></vliveExample>
            </el-tab-pane>
        </el-tabs>

    </div>
</div>
</template>

<script>
import VliveHeader from 'views/cms/vlive/components/vliveHeader'
import VliveExample from 'views/cms/vlive/components/vliveExample'
import VliveExampleWechatShare from 'views/cms/vlive/components/vliveExampleWechatShare'
import VliveExampleGuideCover from 'views/cms/vlive/components/vliveExampleGuideCover'
import VliveCover from 'views/cms/vlive/components/vliveCover'
import VliveContent from 'views/cms/vlive/components/vliveContent'
import VliveWeChatShare from 'views/cms/vlive/components/vliveWeChatShare'
import VliveTrailer from 'views/cms/vlive/components/vliveTrailer'
import VliveGuideCover from 'views/cms/vlive/components/vliveGuideCover'
import VliveFollow from 'views/cms/vlive/components/vliveFollow'
import VliveAdv from 'views/cms/vlive/components/vliveAdv'
import VliveSignUp from 'views/cms/vlive/components/vliveSignUp'
import {getVliveHighSetting} from 'api/api'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'vlinePlaybackInterface',
    data() {
        return {
            activeName: 'vliveCover',
            param: {
                assetinnerid: this.$route.query.id ? this.$route.query.id : '' // id
            }
        }
    },
    created() {
        this._getVliveModle()
    },
    methods: {
        handleClick() {

        },
        _getVliveModle () {
            this.setLoading(true)
            getVliveHighSetting({
                data: this.param,
                success: data => {
                    let obj = data.data
                    let item = {
                        assetinnerid: obj.assetinnerid, // 直播ID
                        customerinnerid: obj.customerinnerid, //  会员ID
                        hostinnerid: obj.hostinnerid, //  发布方ID
                        banner: {
                            coverPicture: obj.logoPic
                        },
                        contentthemecolor: obj.contentthemecolor,
                        contentList: [],
                        weChatShare: {
                            sharesubject: obj.sharesubject,
                            sharedesc: obj.sharedesc,
                            coverPicture: obj.sharelogoPic
                        },
                        trailer: {
                            isopenpreview: !!obj.isopenpreview,
                            videoInfo: obj.previewVideo
                        },
                        guideCover: {
                            isopencover: !!obj.isopencover,
                            coverPicture: obj.coverPic
                        },
                        follow: {
                            isopenmp: !!obj.isopenmp,
                            coverPicture: obj.mplogoPic,
                            openmpname: obj.openmpname,
                            mpqrPic: obj.mpqrPic
                        },
                        adv: {
                            isopenad: !!obj.isopenad,
                            list: []
                        },
                        signUp: {
                            isopenenroll: !!obj.isopenenroll,
                            coverPicture: obj.enrolliconPic,
                            enrollurl: obj.enrollurl
                        }
                    }
                    if (this.vliveModel.contentList.length > 0) {
                        item.contentList = this.vliveModel.contentList
                    }
                    if (this.vliveModel.adv.list && this.vliveModel.adv.list.length > 0) {
                        item.adv.list = this.vliveModel.adv.list
                    }
                    this.setVliveModel(item)
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setVliveModel'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'vliveModel',
            'loading'
        ])
    },
    components: {
        VliveHeader,
        VliveExample,
        VliveCover,
        VliveContent,
        VliveWeChatShare,
        VliveTrailer,
        VliveGuideCover,
        VliveFollow,
        VliveAdv,
        VliveSignUp,
        VliveExampleWechatShare,
        VliveExampleGuideCover
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vlinePlaybackInterface {
    .playback-interface{
        position: relative;
        .vliveExample,.vliveExampleWechatShare,.vliveExampleGuideCover{
            position: fixed;
            top: 150px;
            right: 0;
            z-index: 1000;
            .phone-model {
                box-sizing: border-box;
                width: 406px;
                height: 782px;
                padding: 143px 42px 0 46px;
            }
        }
    }
    .el-switch__label--right{
        color: $tcolor-grey;
    }
    .switch{
        font-size: $font-14;
        .el-switch{
            margin-left: 10px;
        }
        color: $tcolor-gray;
    }
    .el-switch.is-disabled{
        opacity: 1;
    }
    .el-switch.is-disabled .el-switch__core, .el-switch.is-disabled .el-switch__label{
        cursor: pointer;
    }
}
</style>
